import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import BasicButton from '@/components/Common/Button/BasicButton';
import MenuHeader from '@/components/Header/MenuHeader';
import { colors } from '@/const/colors';

const SignUpSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDealerSignUp = (location.state as { signUpType?: string })?.signUpType === 'DEALER';

  const onClickGoToLogin = () => {
    navigate('/');
  };

  // 네이버 회원가입 전환 스크립트
  useEffect(() => {
    // 외부 스크립트 로드
    const script = document.createElement('script');
    script.src = '//wcs.naver.net/wcslog.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const w = window as any;
      if (w.wcs) {
        if (!w.wcs_add) w.wcs_add = {};
        // TODO: 실제 발급받은 AccountId 로 교체 필요
        w.wcs_add['wa'] = 's_54be5a43f6f3';

        const _conv: any = {};
        _conv.type = 'sign_up';
        w.wcs.trans(_conv);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="w-full h-[100dvh] p-4 flex flex-col justify-between relative min-h-[540px]">
        <MenuHeader title="회원가입 완료"></MenuHeader>
        <div></div>
        <div
          className={`absolute top-[15%] left-4 font-bold text-4xl xxs:text-3xl xs:text-3xl leading-normal ml-2 mt-15`}
        >
          <img
            src="https://zigtruck-service-public-image.s3.ap-northeast-2.amazonaws.com/logo.png"
            alt="직트럭 로고"
            className="w-20 mb-4"
          ></img>
          {isDealerSignUp ? (
            <>
              딜러 회원가입으로
              <br /> 신청되었습니다!
            </>
          ) : (
            <>
              회원가입이
              <br /> 완료되었습니다!
            </>
          )}
          {isDealerSignUp && (
            <div className="text-[24px] text-gray-7 mt-4">
              <p>담당자가 확인 후 승인시</p>
              <p>로그인 하실수 있어요.</p>
              <br />
              <p>승인까지 잠시만 기다려주세요</p>
            </div>
          )}
        </div>

        <div className="pb-[60px]">
          <BasicButton
            name="홈으로"
            bgColor={colors.primary[10]}
            borderColor={colors.primary[10]}
            textColor={colors.gray[0]}
            fontSize={16}
            height={48}
            borderRadius={12}
            fontWeight="semibold"
            onClick={() => onClickGoToLogin()}
          ></BasicButton>
        </div>
      </div>
    </>
  );
};

export default SignUpSuccess;
